import type { Translations } from '../types';

export const ar: Translations = {
  nav: {
    items: [
      { title: 'من نحن', id: 'about', isSection: true },
      { title: 'خدماتنا', id: 'services', isSection: true },
      { title: 'الأسئلة الشائعة', id: 'faq', isSection: true },
      { title: 'مقدمي الخدمات', id: 'service-provider', isSection: false },
    ],
    home: 'الرئيسية',
    vendorButton: 'دخول المزوّد',
    customerButton: 'الدخول كعميل',
    mobileVendorButton: 'دخول الطبيب',
    mobileCustomerButton: 'الدخول كعميل',
  },
  hero: {
    brandName: 'ميد هب',
    title: 'منصتك المركزية للخدمات الطبية الميدانية',
    description:
      'احصل على عروض أسعار من مقدمي خدمات طبية مرخصين، قارن بينها، واختر الأنسب لمشروعك أو فعاليتك، كل ذلك عبر منصة واحدة موثوقة',
    joinAsVendor: 'الانضمام كمزوّد للخدمات',
    registerAsCustomer: 'الانضمام كعميل',
  },
  about: {
    title: 'من نحن؟',
    description:
      'ميد هب منصة رقمية سعودية تربط بين طالبي الخدمات الطبية الميدانية ومقدميها المرخصين، بهدف تسهيل عملية الحصول على التغطية الطبية المطلوبة للمشاريع والفعاليات بكفاءة وشفافية عالية عمل المنصة كسوق إلكتروني متخصص يجمع بين الشركات والمؤسسات التي تحتاج إلى خدمات طبية ميدانية، وبين العيادات والمراكز الطبية المرخصة القادرة على تقديم هذه الخدمات وفق أعلى معايير الجودة والسلامة',
    vision: {
      title: 'رؤيتنا',
      description:
        'أن نكون المنصة الرائدة في المملكة لربط طالبي الخدمات الطبية الميدانية بمقدميها',
      alt: 'رؤيتنا',
    },
    mission: {
      title: 'مهمتنا',
      description:
        'تمكين الشركات من الحصول على خدمات طبية ميدانية موثوقة بسرعة وسهولة',
      alt: 'مهمتنا',
    },
  },
  services: {
    title: 'خدماتنا',
    items: [
      {
        id: 'ambulances',
        title: 'سيارات الإسعاف',
        description:
          'سيارات إسعاف مجهزة بالكامل مع طواقم طبية مؤهلة للتواجد في مواقع المشاريع والفعاليات',
      },
      {
        id: 'mobile-clinics',
        title: 'العيادات المتنقلة',
        description:
          'عيادات متنقلة مجهزة بأحدث المعدات الطبية لتقديم الخدمات الصحية الأساسية',
      },
      {
        id: 'medical-teams',
        title: 'الفرق الطبية الميدانية',
        description:
          'فرق طبية متكاملة تشمل أطباء وممرضين ومسعفين للتواجد الميداني',
      },
      {
        id: 'medical-equipment',
        title: 'المعدات الطبية',
        description:
          'توفير المعدات والمستلزمات الطبية والإسعافية حسب متطلبات المشروع',
      },
    ],
  },
  whyChooseUs: {
    title: 'لماذا ميد هب؟',
    features: {
      transparentComparison: {
        title: 'مقارنة شفافة',
        description:
          'قارن بين العروض من حيث السعر والمواصفات والتقييمات السابقة',
      },
      fastOffers: {
        title: 'سرعة الحصول على العروض',
        description:
          'احصل على عروض أسعار متعددة من مقدمي خدمات مؤهلين خلال وقت قياسي',
      },
      secureContracts: {
        title: 'عقود رقمية آمنة',
        description: 'أتمم التعاقد إلكترونياً مع ضمانات مالية وقانونية',
      },
      licensedProviders: {
        title: 'مقدمو خدمات مرخصون',
        description: 'جميع مقدمي الخدمات معتمدون ومرخصون من الجهات المختصة',
      },
      continuousSupport: {
        title: 'دعم متواصل',
        description: 'فريق دعم متخصص لمساعدتك في جميع مراحل العملية',
      },
    },
  },
  sectorsWeServe: {
    title: 'القطاعات التي نخدمها',
    sectors: {
      construction: 'الإنشاءات',
      sports: 'الرياضة',
      entertainment: 'الترفيه',
      government: 'الحكومي',
      industrial: 'الصناعي',
    },
  },
  howItWorks: {
    title: 'كيف تعمل المنصة؟',
    steps: {
      register: {
        title: 'سجّل وأنشئ طلبك',
        description:
          'أنشئ حسابك وأدخل تفاصيل طلبك شاملاً نوع الخدمة والموقع والمدة',
      },
      receiveOffers: {
        title: 'استلم العروض',
        description:
          'سيتلقى طلبك مقدمو الخدمات المؤهلون وستستلم عروض أسعار تنافسية',
      },
      compareChoose: {
        title: 'قارن واختر',
        description: 'راجع العروض وقارن بينها واختر العرض الأنسب لاحتياجاتك',
      },
      completeContract: {
        title: 'أتمم التعاقد',
        description: 'أتمم عملية التعاقد والدفع إلكترونياً بشكل آمن ومضمون',
      },
      receiveService: {
        title: 'استلم الخدمة',
        description:
          'يقوم مقدم الخدمة بتنفيذ العمل ويمكنك متابعة وتقييم الخدمة',
      },
    },
  },
  faq: {
    title: 'الأسئلة الشائعة',
    items: [
      {
        question: 'ما هي منصة ميد هب؟',
        answer:
          'منصة رقمية تربط بين طالبي الخدمات الطبية الميدانية ومقدميها المرخصين',
      },
      {
        question: 'ما نوع الخدمات المتاحة؟',
        answer:
          'سيارات الإسعاف، العيادات المتنقلة، الفرق الطبية، والمعدات الطبية',
      },
      {
        question: 'كيف أضمن جودة مقدمي الخدمات؟',
        answer:
          'جميع مقدمي الخدمات مرخصون ويمكنك الاطلاع على تقييمات العملاء السابقين',
      },
      {
        question: 'كم يستغرق الحصول على العروض؟',
        answer: 'عادةً من ٢٤ إلى ٤٨ ساعة حسب طبيعة الخدمة المطلوبة',
      },
      {
        question: 'هل الخدمة متاحة في جميع المناطق؟',
        answer: 'نعم، المنصة متاحة في جميع مناطق المملكة العربية السعودية',
      },
    ],
  },
  serviceProvider: {
    hero: {
      title: ' مقدمي الخدمات',
      subtitle: 'انضم إلى ميد هب — وسّع نطاق أعمالك واحصل على فرص جديدة',
      cta: 'انضم الآن',
    },
    whyJoin: {
      title: 'لماذا تنضم إلى ميد هب؟',
      features: {
        fairCompetition: {
          title: 'منافسة عادلة',
          description: 'نظام عروض شفاف يضمن تكافؤ الفرص',
        },
        newOpportunities: {
          title: 'فرص عمل جديدة',
          description: 'استقبل طلبات من شركات ومؤسسات دون جهود تسويق',
        },
        guaranteedPayments: {
          title: 'دفعات مضمونة',
          description: 'نظام دفع آمن يضمن حصولك على مستحقاتك',
        },
        easyManagement: {
          title: 'إدارة سهلة',
          description: 'لوحة تحكم متكاملة لإدارة كل شيء',
        },
        professionalReputation: {
          title: 'سمعة مهنية',
          description: 'ابنِ سمعتك من خلال تقييمات العملاء',
        },
      },
    },
    howToStart: {
      title: 'كيف تبدأ كمقدم خدمة؟',
      steps: [
        {
          title: 'سجّل حسابك',
          description: 'أنشئ حساب مقدم خدمة وأكمل بيانات منشأتك',
        },
        {
          title: 'أرفق الوثائق',
          description: 'حمّل التراخيص والشهادات المطلوبة',
        },
        {
          title: 'انتظر التفعيل',
          description: 'سيتم مراجعة وثائقك وإشعارك عند التفعيل',
        },
        {
          title: 'استقبل الطلبات',
          description: 'ابدأ باستقبال طلبات العملاء المناسبة',
        },
        {
          title: 'قدّم عروضك',
          description: 'قدّم عروض أسعار تنافسية للفوز بالعقود',
        },
      ],
    },
    requiredDocuments: {
      title: 'الوثائق المطلوبة',
      items: [
        'السجل التجاري ساري المفعول',
        'ترخيص مزاولة النشاط الطبي',
        'شهادة التأمين المهني',
        'قائمة الكوادر الطبية المرخصة',
        'قائمة المعدات والمركبات',
      ],
    },
  },
  footer: {
    tagline: 'منصتك الذكية للخدمات\nالطبية الميدانية',
    quickLinks: 'روابط سريعة',
    contactUs: 'تواصل معنا',
    email: 'info@tgl.com.sa',
    phone: '+966 11 202 7444',
    copyright:
      '© {year} MedHub - Al Takassusi General Limited Company . All rights reserved',
    termsAndPrivacy: 'سياسة الاستخدام والخصوصية',
  },
  languageSwitcher: {
    label: 'English',
  },
  seo: {
    home: {
      title: 'ميد هب — منصتك المركزية للخدمات الطبية الميدانية في السعودية',
      description:
        'منصة سعودية تربط طالبي الخدمات الطبية الميدانية بمقدميها المرخصين. احصل على عروض أسعار من سيارات إسعاف وعيادات متنقلة وفرق طبية، قارن، واختر الأنسب لمشروعك أو فعاليتك.',
    },
    serviceProvider: {
      title: 'انضم كمقدم خدمات طبية ميدانية | ميد هب',
      description:
        'انضم إلى ميد هب لتوسيع نطاق أعمالك واستقبال طلبات من شركات ومؤسسات تحتاج خدمات طبية ميدانية مرخصة في جميع مناطق المملكة العربية السعودية.',
    },
  },
};
